import { call, takeLatest } from 'redux-saga/effects';
import { NotificationMessages, TwoFATypes } from 'shared/enums';
import { TAction } from 'shared/types';
import { change2FAType as change2FATypeAction } from './auth.redux';
import AuthService from '../../shared/services/AuthService';
import { openNotificationMessage } from 'shared/utils/NotificationMessages';

function* change2FAType({ payload }: TAction<TwoFATypes>) {
  try {
    yield call(AuthService.changeType2fa, payload);
    yield call(AuthService.getOtpCode);
  } catch (error: any) {
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data.message ||
        'Two factor authentication changing failed.'
    });
  }
}

function* Auth() {
  yield takeLatest(change2FATypeAction.type, change2FAType);
}

export default Auth;
